import React from "react";
import { EditorTools, EditorToolsSettings } from "@progress/kendo-react-editor";
import { JSX } from "react/jsx-runtime";

const { ForeColor } = EditorTools;

/**
 * Custom ForeColor component with predefined styling and color palette
 * Provides text color selection functionality for the WYSIWYG editor
 */
export const CustomForeColor = (
  props: JSX.IntrinsicAttributes & EditorTools.ForeColorProps
) => (
  <ForeColor
    {...props}
    colorPickerProps={{
      ...props.colorPickerProps,
      defaultValue: "#000000",
      svgIcon: EditorToolsSettings.foreColor.colorPickerProps.svgIcon,
      paletteSettings: {
        ...props.colorPickerProps?.paletteSettings,
        palette: "basic"
      }
    }}
  />
);

export default CustomForeColor;
